import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { GA4_APP_PLAY_GAME_EVENT } from "@/feature-analytics/google.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

export async function onEnterTftGame(payload) {
  refs.gtag("event", GA4_APP_PLAY_GAME_EVENT, {
    ...(await refs.getIdentifyingInfo()),
    game: "tft",
  });

  return refs.trackEvent(ANALYTIC_EVENTS.TFT_START, payload);
}

export function onExitTftGame(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.TFT_END, payload);
}

export function onLpChangeTft(payload) {
  return refs.trackEvent(
    ANALYTIC_EVENTS.TFT_LP_CHANGE,
    Object.assign(
      {
        [refs.isImmediate]: true,
      },
      payload,
    ),
  );
}

export function onPostmatchTft(payload) {
  return refs.trackEvent(
    ANALYTIC_EVENTS.TFT_POSTMATCH,
    Object.assign(
      {
        [refs.isImmediate]: true,
      },
      payload,
    ),
  );
}

export function onRoundDataTft(payload) {
  return refs.trackEvent(
    ANALYTIC_EVENTS.TFT_ROUND_DATA,
    Object.assign(
      {
        [refs.isImmediate]: true,
      },
      payload,
    ),
  );
}

export function onOverlayUsageTft(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.TFT_OVERLAY_USAGE, payload);
}
